import React, { Component } from 'react';
import {number_input_format} from './helper/format';
import {
  isMobile
} from "react-device-detect";

class Footer extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      monthTotalPrice : 0,
      monthCommission : 0,
	  sold_out: 0
    };
  }
  display(_monthTotalPrice,_monthCommission, sold_out)
  {
      this.setState({
        monthTotalPrice : _monthTotalPrice,
        monthCommission : _monthCommission,
		sold_out: sold_out
      });
  }
  goComplete()
  {
    //window.location.href = '/OrderComplete';
	if( this.state.sold_out === 0 ) {
    	this.props.onComplete('O');
	} else {
		alert('품절 상품의 경우 전화상담과 채팅상담만 가능합니다');
	}
  }
  tellComplete()
  {
    this.props.onComplete();
  }
  chatComplete()
  {
    this.props.onComplete();
  }

  goChat()
  {
    this.props.onComplete('C');
  }

  goCall()
  {
    //1599-5168
    this.props.onComplete('T');
  }
  render()
  {
    const self = this;
      return (
              <div>
                  {(isMobile) ?
                    <div className="DetailMobileFooter">
                      <div className="row text-center">
                        <div className="row">
                          <div className="col-xs-4">
                            <div className="ml15">
                              <div className="topside2 font10">&nbsp; 월 단말 분할 상환금</div>
                              <div className="topbottom3">{number_input_format(self.state.monthTotalPrice)}원</div>
                            </div>
                          </div>
                          <div className="col-xs-4">
                            <div className="mr15">
                              <div className="topside2 font10">월 통신요금</div>
                              <div className="topbottom3">{number_input_format(self.state.monthCommission)}원</div>
                            </div>
                          </div>
                          <div className="col-xs-4 pl0">
                            <div className="topside2 font10">월 납부금액</div>
                            <div className="topbottom3 redtext bold">{number_input_format(self.state.monthTotalPrice + self.state.monthCommission)}원</div>
                          </div>
                        </div>
                        <div className="row pt10">
                            <a href="#order" onClick={()=>{self.goCall()}} className="btn btn-call btn-xs  font14"> <i className="fas fa-headset"></i>&nbsp;&nbsp;전화상담</a>&nbsp;&nbsp;&nbsp;
                            <a href="#order" onClick={()=>{self.goChat()}} className="btn btn-chat btn-xs  font14" ><i className="fas fa-comments"></i>&nbsp;&nbsp;채팅상담</a>&nbsp;&nbsp;&nbsp;
                            <a href="#order" onClick={()=>{self.goComplete()}} className="btn btn-bar btn-xs  font14"><i className="fas fa-shopping-cart"></i>&nbsp;&nbsp;주문하기</a>
                        </div>
                      </div>
                    </div>
                    :
                    <div className="DetailFooter">
                        <div className="container">
                              <div className="row pt30">

                                <div className="col-md-7">
                                  <div className="col-md-3">
                                    <div className="topside">월 단말 분할 상환금</div>
                                    <div className="topbottom">{number_input_format(self.state.monthTotalPrice)}원</div>
                                  </div>
                                  <div className="col-md-1 giho">
                                    +
                                  </div>
                                  <div className="col-md-3">
                                    <div className="topside">월 통신요금</div>
                                    <div className="topbottom">{number_input_format(self.state.monthCommission)}원</div>
                                  </div>
                                  <div className="col-md-1 giho">
                                    =
                                  </div>
                                  <div className="col-md-4 mt-4">
                                    <div className="topside">월 납부금액 <span className="tombottom_impo">{number_input_format(self.state.monthTotalPrice + self.state.monthCommission)}원</span></div>
                                    <div className="topbottom2">(분할상환 수수료 5.9% 포함)</div>
                                  </div>
                                </div>

                                <div className="col-md-5 text-right pr0 pl0">
                                    <a href="#order" onClick={()=>{self.goCall()}} className="btn btn-call btn-sm btn-order-padding font18"> <i className="fas fa-headset"></i>&nbsp;&nbsp;전화상담</a>&nbsp;&nbsp;&nbsp;
                                    <a href="#order" onClick={()=>{self.goChat()}} className="btn btn-chat btn-sm btn-order-padding font18" ><i className="fas fa-comments"></i>&nbsp;&nbsp;채팅상담</a>&nbsp;&nbsp;&nbsp;
                                    <a href="#order" onClick={()=>{self.goComplete()}} className="btn btn-bar btn-sm btn-order-padding font18"><i className="fas fa-shopping-cart"></i>&nbsp;&nbsp;주문하기</a>
                                </div>
                              </div>
                      </div>
                  </div>
                  }
                </div>
                );
  }
}


export default Footer;
